import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { PEDIDOS_NAO_LIBERADOS_API_RESOURCE } from '../consts';
import { PedidoLiberarRequest } from '../adapters';
import { PedidoIsLiberadoRequest, PedidoIsLiberadoResponse } from '../adapters';

@Injectable({
    providedIn: 'root'
})
export class PedidoNaoLiberadoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${PEDIDOS_NAO_LIBERADOS_API_RESOURCE}`;
    }

    /** Verifica se um pedido está liberado conforme as regras comerciais */
    isLiberado(idPedido: number, req: PedidoIsLiberadoRequest): Observable<PedidoIsLiberadoResponse> {
        return this.customHttp.post<PedidoIsLiberadoResponse>(`${this.pathApi}/${idPedido}/liberado`, req);
    }

    /** Realiza a liberação do pedido informado */
    liberar(req: PedidoLiberarRequest): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/0/liberar`, req);
    }
}
